import ServicePage from "@/components/ServicePage";

export default function Rentals() {
  return (
    <ServicePage
      type="Rentals"
      path="/rentals"
      title="Try before you buy — eBike rentals"
      subtitle="Rent a premium electric bike by the day, week or month. Rental cost is redeemable against purchase."
      image="https://images.unsplash.com/photo-1730948166113-4728bdb89979?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      seoTitle="eBike Rentals — Hire a Premium Electric Bike in Kent"
      seoDesc="Rent a premium electric bike by the day, week or month in Canterbury, Kent. Try mountain, city, folding & cargo ebikes. Rental cost redeemable against purchase at Ebikes&Gear."
      cta="Reserve a Rental"
      intro={{
        heading: "Experience the freedom, then make it yours",
        text: "Not sure which ebike is right for you? Rent one and find out. Our flexible rentals let you test premium models in real life — and if you buy, we'll deduct your rental cost from the price.",
      }}
      perks={["Helmet & lock included", "Full insurance available", "Free safety briefing", "Flexible day/week/month terms", "Cost redeemable on purchase", "Wide range of models"]}
      packages={{
        heading: "Rental rates",
        items: [
          { name: "Day rental", desc: "Perfect for a weekend adventure", price: "from £39" },
          { name: "Weekly rental", desc: "Commute test or holiday", price: "from £149" },
          { name: "Monthly rental", desc: "Long-term flexibility", price: "from £399" },
          { name: "Try-before-buy", desc: "Redeemable against purchase", price: "100% back" },
        ],
      }}
    />
  );
}
